import { render, staticRenderFns } from "./promoting.vue?vue&type=template&id=4372d557&"
import script from "./promoting.vue?vue&type=script&lang=js&"
export * from "./promoting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports